// signInReducer.js
const initialState = {
  usernameError: false,
  usernameErrorMessage: '',
  passwordError: false,
  passwordErrorMessage: '',
  email: '',
  username: '',
  password: '',
  inProgress: false,
  loading4SignIn: false,
  credential: '',  
};

export default function signInReducer(state = initialState, action) {
  switch (action.type) {
    case 'setCredential':
      return {
        ...state,
        credential: action.payload,
      };      
    case 'setUsernameError':
      return {
        ...state,
        usernameError: action.payload,
      };
    case 'setUsernameErrorMessage':
      return {
        ...state,
        usernameErrorMessage: action.payload,
      };     
    case 'setPasswordError':
      return {
        ...state,
        passwordError: action.payload,
      };  
    case 'setPasswordErrorMessage':
      return {
        ...state,
        passwordErrorMessage: action.payload,
      };  
    case 'setInProgress':
      return {
        ...state,
        inProgress: action.payload, // Update the selected book
      };        
    case 'setPassword':
      return {
        ...state,
        password: action.payload, // Update the selected book
      };  
    case 'setEmail':
      return {
        ...state,
        email: action.payload, // Update the selected book
      };              
    case 'setUsername':
      return {
        ...state,
        username: action.payload, // Update the selected book
      };     
    case 'reset4SignIn':
      return initialState;     
    default:
      return state;
  }
}

export const setCredential = (e) => ({
  type: 'setCredential',
  payload: e,
});

export const setUsernameError = (e) => ({
  type: 'setUsernameError',
  payload: e,
});

export const setUsernameErrorMessage = (e) => ({
  type: 'setUsernameErrorMessage',
  payload: e,
});

export const setPasswordError  = (e) => ({
  type: 'setPasswordError',
  payload: e,
});

export const setPasswordErrorMessage  = (e) => ({
  type: 'setPasswordErrorMessage',
  payload: e,
});

export const setInProgress = (e) => ({
  type: 'setInProgress',
  payload: e,
});

export const setPassword = (e) => ({
  type: 'setPassword',
  payload: e,
});

export const setEmail = (e) => ({
  type: 'setEmail',
  payload: e,
});

export const setUsername = (e) => ({
  type: 'setUsername',
  payload: e,
});

export const reset4SignIn  = (e) => ({
  type: 'reset4SignIn',
  payload: e,
});